import { render } from "./AddCustomFields.vue?vue&type=template&id=2ae6acb0"
import script from "./AddCustomFields.vue?vue&type=script&lang=js"
export * from "./AddCustomFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__